"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaceDetails = exports.Races = void 0;
exports.getRaceBonus = getRaceBonus;
const playerTraits_1 = require("./playerTraits");
var Races;
(function (Races) {
    Races["HUMAN"] = "HUMAN";
    Races["WONDERKID"] = "WONDERKID";
    Races["ORC"] = "ORC";
    Races["DOG"] = "DOG";
    Races["WIZARD"] = "WIZARD";
    Races["DEVIL"] = "DEVIL";
    Races["BULL"] = "BULL";
    Races["CELESTIAL"] = "CELESTIAL";
    Races["GOAT"] = "GOAT";
    Races["HERO"] = "HERO";
    Races["SUPER_HERO"] = "SUPER_HERO";
    Races["HALFLING"] = "HALFLING";
    Races["MERMAID"] = "MERMAID";
    Races["MERMAN"] = "MERMAN";
    Races["DRAGON"] = "DRAGON";
    Races["ELF"] = "ELF";
    Races["MACHINE"] = "MACHINE";
    Races["GIANT"] = "GIANT";
    Races["KNIGHT"] = "KNIGHT";
    Races["KING"] = "KING";
    Races["DINOSAUR"] = "DINOSAUR";
    Races["LION"] = "LION";
    Races["DIVINE"] = "DIVINE";
    Races["GOLEM"] = "GOLEM";
    Races["LIZARD"] = "LIZARD";
    Races["WRAITH"] = "WRAITH";
    Races["LICH"] = "LICH";
    Races["GLADIATOR"] = "GLADIATOR";
    Races["CENTURION"] = "CENTURION";
    Races["TORCH"] = "TORCH";
    Races["ICE_MAN"] = "ICE_MAN";
})(Races || (exports.Races = Races = {}));
exports.RaceDetails = {
    [Races.HUMAN]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [
            playerTraits_1.PlayerTraits.VERSATILE, //Will be replaced by adaptable once implemented, versatile then needs to be a role and granted as Dutch national bonus
        ],
    },
    [Races.WONDERKID]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [
            playerTraits_1.PlayerTraits.LUCKY, //Will be replaced by adaptable once implemented, versatile then needs to be a role and granted as Dutch national bonus
            playerTraits_1.PlayerTraits.STAR,
        ],
    },
    [Races.ELF]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RAPID],
    },
    [Races.ORC]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.POWERFUL],
    },
    [Races.DOG]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.MANS_BEST_FRIEND],
    },
    [Races.WIZARD]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FLAIR, playerTraits_1.PlayerTraits.WISE],
    },
    [Races.DEVIL]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SOUL_SAP, playerTraits_1.PlayerTraits.DOMINANT],
    },
    [Races.BULL]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.CHARGE, playerTraits_1.PlayerTraits.POWERFUL],
    },
    [Races.CELESTIAL]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAR],
    },
    [Races.GOAT]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [
            playerTraits_1.PlayerTraits.STAR,
            playerTraits_1.PlayerTraits.LEGEND_OF_LEGENDS,
            playerTraits_1.PlayerTraits.CHARGE,
        ],
    },
    [Races.HERO]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HERO],
    },
    [Races.HALFLING]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LUCKY],
    },
    [Races.MERMAID]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FLAIR],
    },
    [Races.MERMAN]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FLAIR],
    },
    [Races.DRAGON]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.IGNITE, playerTraits_1.PlayerTraits.DOMINANT],
    },
    [Races.SUPER_HERO]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HERO, playerTraits_1.PlayerTraits.DETERMINED],
    },
    [Races.MACHINE]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.GOAL_MACHINE, playerTraits_1.PlayerTraits.RELIABLE],
    },
    [Races.GIANT]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.POWERFUL, playerTraits_1.PlayerTraits.TARGET],
    },
    [Races.KNIGHT]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHIELD],
    },
    [Races.KING]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DOMINANT, playerTraits_1.PlayerTraits.INSPIRE],
    },
    [Races.DINOSAUR]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.POWERFUL, playerTraits_1.PlayerTraits.LETHAL],
    },
    [Races.LION]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LETHAL, playerTraits_1.PlayerTraits.DOMINANT],
    },
    [Races.DIVINE]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LUCKY, playerTraits_1.PlayerTraits.INSPIRE],
    },
    [Races.GOLEM]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.POWERFUL, playerTraits_1.PlayerTraits.UNYIELDING],
    },
    [Races.LIZARD]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RAPID, playerTraits_1.PlayerTraits.RECOVER],
    },
    [Races.WRAITH]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNDEAD],
    },
    [Races.LICH]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DOMINANT, playerTraits_1.PlayerTraits.UNDEAD],
    },
    [Races.GLADIATOR]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNYIELDING, playerTraits_1.PlayerTraits.LETHAL],
    },
    [Races.CENTURION]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHIELD, playerTraits_1.PlayerTraits.ORGANISED],
    },
    [Races.TORCH]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [
            //
            playerTraits_1.PlayerTraits.IGNITE,
        ],
    },
    [Races.ICE_MAN]: {
        statBlock: {},
        positionsEnabled: [],
        playerTraits: [
            playerTraits_1.PlayerTraits.UNYIELDING,
            playerTraits_1.PlayerTraits.DETERMINED, //Replace with "Cold Blooded" trait when available
        ],
    },
};
function getRaceBonus(race) {
    return exports.RaceDetails[race];
}
